export default [
    {
        comment: '',
        error_id: 'FW 03',
        data: [
            {cross_section: '43827'},
            {cross_section: '43002'},
        ]
    }
]